import Tickets from '../../views/tickets/Tickets.vue'
import Ticket from '../../views/tickets/Ticket.vue'
import ResolvedTickets from '../../views/tickets/ResolvedTickets.vue'

import {roleSystemRoute} from './route_utilities'

export const tickets =  {
      path: 'tickets',
      name: 'Tickets',
      component: Tickets,
      meta: {
          title: "destek",
          domain:"tickets",
          accessroles:["admin","planner","auditor"],
        },
      }

  export const resolved_tickets =  {
  path: 'resolved_tickets',
  name: 'ResolvedTickets',
  component: ResolvedTickets,
  meta: {
      title: "cozumlenmis_destek_talepleri",
      domain:"tickets",
      accessroles:["admin","planner","auditor"],
    },
  }


export const ticket =  {
      path: 'ticket/:id',
      name: 'Ticket',
      component: Ticket,
      meta: {
          title: "destek",
          domain:"tickets",
          accessroles:["admin","planner","auditor"],
        },
      }